import '../assets/NcProgressBar--z-WqmX4.css';
import { createElementBlock, openBlock, normalizeClass, normalizeStyle, createElementVNode, useCssVars } from "vue";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
const _sfc_main = {
  name: "NcProgressBar",
  props: {
    /**
     * An integer between 1 and 100
     */
    value: {
      type: Number,
      default: 0,
      validator(value) {
        return value >= 0 && value <= 100;
      }
    },
    /**
     * Determines the height of the progressbar.
     * Possible values:
     * - 'small' (default)
     * - 'medium'
     * - Number
     * @type {'small'|'medium'|number}
     */
    size: {
      type: [String, Number],
      default: "small",
      validator(value) {
        return ["small", "medium"].includes(value) || typeof value === "number";
      }
    },
    /**
     * Applies an error color to the progressbar if true.
     */
    error: {
      type: Boolean,
      default: false
    },
    /**
     * ProgressBar type
     */
    type: {
      type: String,
      default: "linear",
      validator(value) {
        return ["linear", "circular"].includes(value);
      }
    },
    color: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      stroke: 4
    };
  },
  computed: {
    height() {
      if (this.type === "circular") {
        if (Number.isInteger(this.size)) {
          return this.size;
        }
        return 44;
      }
      if (this.size === "small") {
        return 4;
      } else if (this.size === "medium") {
        return 6;
      }
      return this.size;
    },
    progress() {
      return this.value / 100;
    },
    radius() {
      return this.height / 2;
    },
    radiusNormalized() {
      return this.radius - 3 * this.stroke;
    },
    circumference() {
      return this.radiusNormalized * 2 * Math.PI;
    }
  }
};
const __injectCSSVars__ = () => {
  useCssVars((_ctx) => ({
    "497e8a2b": _ctx.color
  }));
};
const __setup__ = _sfc_main.setup;
_sfc_main.setup = __setup__ ? (props, ctx) => {
  __injectCSSVars__();
  return __setup__(props, ctx);
} : __injectCSSVars__;
const _hoisted_1 = ["aria-valuenow"];
const _hoisted_2 = ["height", "width"];
const _hoisted_3 = ["stroke-dasharray", "stroke-dashoffset", "stroke-width", "r", "cx", "cy"];
const _hoisted_4 = ["stroke-dasharray", "stroke-dashoffset", "stroke-width", "r", "cx", "cy"];
const _hoisted_5 = ["value"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.type === "circular" ? (openBlock(), createElementBlock("span", {
    key: 0,
    role: "progressbar",
    "aria-valuenow": $props.value,
    style: normalizeStyle({ "--progress-bar-height": $options.height + "px" }),
    class: normalizeClass([{ "progress-bar--error": $props.error }, "progress-bar progress-bar--circular"])
  }, [
    (openBlock(), createElementBlock("svg", {
      height: $options.height,
      width: $options.height
    }, [
      createElementVNode("circle", {
        stroke: "currentColor",
        fill: "transparent",
        "stroke-dasharray": `${$options.progress * $options.circumference} ${(1 - $options.progress) * $options.circumference}`,
        "stroke-dashoffset": 0.25 * $options.circumference,
        "stroke-width": $data.stroke,
        r: $options.radiusNormalized,
        cx: $options.radius,
        cy: $options.radius
      }, null, 8, _hoisted_3),
      createElementVNode("circle", {
        stroke: "var(--color-background-darker)",
        fill: "transparent",
        "stroke-dasharray": `${(1 - $options.progress) * $options.circumference} ${$options.progress * $options.circumference}`,
        "stroke-dashoffset": (0.25 - $options.progress) * $options.circumference,
        "stroke-width": $data.stroke,
        r: $options.radiusNormalized,
        cx: $options.radius,
        cy: $options.radius
      }, null, 8, _hoisted_4)
    ], 8, _hoisted_2))
  ], 14, _hoisted_1)) : (openBlock(), createElementBlock("progress", {
    key: 1,
    class: normalizeClass(["progress-bar progress-bar--linear vue", { "progress-bar--error": $props.error }]),
    style: normalizeStyle({ "--progress-bar-height": $options.height + "px" }),
    value: $props.value,
    max: "100"
  }, null, 14, _hoisted_5));
}
const NcProgressBar = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-5e97fe1f"]]);
export {
  NcProgressBar as N
};
//# sourceMappingURL=NcProgressBar-Bx8bMkd4.mjs.map
